import React, { Component } from "react";
import "./Mentors.scss";
import dataJSON from "../../static/api/data.json";

const Mentor = props => {
    return (
        <div className={`mentor image-${props.image}`}
            onClick={() => {
                window.open(props.link, "_blank");
            }}>
            {/* <a href={props.link} target="_blank"> */}
            <div className="desc">
                <div className="name">{props.name}</div>
                <div className="title">{props.desc}</div>
            </div>
            <div className="bluefade">
                <div className="name">{props.name}</div>
            </div>
            {/* </a> */}
        </div>
    )
}

export default class Mentors extends Component {
    constructor() {
        super();
        this.state = {};
    }
    renderMentors() {
        return dataJSON.map((item, index) => <Mentor key={index} index={index} {...item} />)
    }
    render() {
        return (
            <section className="section section-mentors">
                <div className="padding">
                    <div className="container">
                        {this.renderMentors()}
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Mentors/Mentors.jsx